export const ignoredMessages = [
  /ttd_dom_ready is not defined/,
  /getRestrictions is not a function/,
  /_AutofillCallbackHandler/,
];
